import React from 'react';
import { useTranslation } from 'react-i18next';
import LifecycleTypeTab from './LifecycleTypeTab';
import { getOnboardingTaskTypes, addOnboardingTaskType, updateOnboardingTaskType, deleteOnboardingTaskType } from '../../../../../api/Employee/lifecycleSettings';

const OnboardingTaskTypesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LifecycleTypeTab
      title={t('Onboarding Task Types')}
      description={t('Configure task categories for the onboarding process such as documents, training, and IT setup')}
      emptyMessage={t('No onboarding task types configured yet')}
      emptyIcon="UserPlus"
      addLabel={t('Add Onboarding Task Type')}
      editLabel={t('Edit Onboarding Task Type')}
      deleteLabel={t('Delete Onboarding Task Type')}
      nameLabel={t('Task type name')}
      namePlaceholder={t('e.g., Document')}
      successAddMessage={t('Onboarding task type added successfully')}
      successUpdateMessage={t('Onboarding task type updated successfully')}
      successDeleteMessage={t('Onboarding task type deleted successfully')}
      failAddMessage={t('Failed to save onboarding task type')}
      failDeleteMessage={t('Failed to delete onboarding task type')}
      deleteConfirmMessage={t('Are you sure you want to delete')}
      duplicateMessage={t('An onboarding task type with this name already exists')}
      fetchItems={getOnboardingTaskTypes}
      addItem={addOnboardingTaskType}
      updateItem={updateOnboardingTaskType}
      deleteItem={deleteOnboardingTaskType}
      testIdPrefix="onboarding-task-type"
    />
  );
};

export default OnboardingTaskTypesTab;
